import { html, LitElement } from 'lit';

export class Monthly extends LitElement {
    static get properties() {
        return {
            frequency: Object,
            readOnly: { type: Boolean, attribute: 'readonly' },
            disabled: { type: Boolean, attribute: 'disabled' },
            isValidStartDate: Function,
            isValidEndDate: Function,
            isStartDateInvalid: Function,
            isEndDateInvalid: Function,
        };
    }

    static get is() {
        return 'omega-frequency-monthly';
    }

    setFrequency(e) {
        this.frequency = e.detail;
        this.dispatchEvent(new CustomEvent('change', { detail: e.detail, bubbles: false }));
    }

    render() {
        return html`
            <omega-frequency-repeat-on-days
                .frequency=${this.frequency}
                @change=${this.setFrequency}
                ?disabled=${this.disabled}
                ?readonly=${this.readOnly}
            ></omega-frequency-repeat-on-days>
            <omega-frequency-start-and-end
                .frequency=${this.frequency}
                .isStartDateInvalid=${this.isStartDateInvalid}
                .isEndDateInvalid=${this.isEndDateInvalid}
                @change=${this.setFrequency}
                ?disabled=${this.disabled}
                ?readonly=${this.readOnly}
            ></omega-frequency-start-and-end>
        `;
    }
}

window.customElements.define(Monthly.is, Monthly);
export default Monthly;
